import React from 'react';

import { ConfettiLayer, ConfettiPiece } from './styles';

const COLORS = ['var(--story-accent)', 'var(--story-text)', 'var(--story-accent-text)'];

// The same scatter on every visit: a fixed pseudo-random number per piece and property.
const PIECES = Array.from({ length: 26 }, (_, id) => {
  const random = (seed) => (((Math.sin(id * 12.9898 + seed * 78.233) * 43758.5453) % 1) + 1) % 1;
  return {
    id,
    style: {
      left: `${random(1) * 100}%`,
      width: 6 + random(2) * 6,
      height: 10 + random(3) * 8,
      borderRadius: random(4) > 0.6 ? '50%' : 2,
      background: COLORS[id % COLORS.length],
      animationDuration: `${3.2 + random(5) * 2.4}s`,
      animationDelay: `${random(6) * 2.5}s`,
    },
  };
});

const Confetti = () => (
  <ConfettiLayer aria-hidden="true">
    {PIECES.map(({ id, style }) => <ConfettiPiece key={id} style={style} />)}
  </ConfettiLayer>
);

export default Confetti;
